export class NotificationAssignmentsModel {
    id: string;
    assignedEndPoints: string[] = [];
    assignedSensors: string[] = [];
}
